import { lazy, Suspense } from "react"
import type { ComponentProps } from "react"

const PdfViewer = lazy(() =>
  import("@/features/file-viewer/components/pdf-viewer").then((m) => ({ default: m.PdfViewer }))
)

type LazyPdfViewerProps = ComponentProps<typeof PdfViewer>

export function LazyPdfViewer(props: LazyPdfViewerProps) {
  return (
    <Suspense
      fallback={
        <div
          aria-live="polite"
          className="flex h-[450px] flex-col items-center justify-center gap-4"
          role="status"
        >
          <div className="flex w-full max-w-sm flex-col gap-3 px-8">
            <div className="skeleton-warm h-4 w-3/4 rounded" />
            <div className="skeleton-warm h-4 w-full rounded" />
            <div className="skeleton-warm h-4 w-5/6 rounded" />
            <div className="skeleton-warm h-4 w-2/3 rounded" />
          </div>
          <span className="sr-only">Loading PDF…</span>
        </div>
      }
    >
      <PdfViewer {...props} />
    </Suspense>
  )
}
